var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardOverviewDailytopissueListIssueidIcon = function SvgNewcsDashboardOverviewDailytopissueListIssueidIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_overview_dailytopissue_list_issueid_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 435h12v12H30z",
    "data-name": "\\u77E9\\u5F62 330"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_overview_dailytopissue_list_issueid_icon_svg__a)",
    transform: "translate(-30 -435)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#807997",
    d: "M31.801 447a1.77 1.77 0 0 1-1.8-1.739v-8.521a1.77 1.77 0 0 1 1.8-1.74h8.4a1.77 1.77 0 0 1 1.8 1.74v8.521a1.77 1.77 0 0 1-1.8 1.739Zm-.6-10.26v8.521a.59.59 0 0 0 .6.58h8.4a.59.59 0 0 0 .6-.58v-8.521a.59.59 0 0 0-.6-.581h-8.4a.59.59 0 0 0-.6.581m3.733 6.58v-4.639h2.067a2.6 2.6 0 0 1 .744.1 1.58 1.58 0 0 1 .818.589 2 2 0 0 1 .342.748 3.5 3.5 0 0 1 .092.769 3 3 0 0 1-.384 1.567 1.75 1.75 0 0 1-1.611.866Zm.976-.806h.925a1 1 0 0 0 .992-.676 2.3 2.3 0 0 0 .153-.884 2.1 2.1 0 0 0-.229-1.088.99.99 0 0 0-.915-.379h-.925Zm-2.909.806v-4.639h1v4.639Z",
    "data-name": 0
  }))));
};
export default SvgNewcsDashboardOverviewDailytopissueListIssueidIcon;